import { Component } from 'react';
import { AlertTriangle, RefreshCw, Database } from 'lucide-react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('React ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    try {
      const DB_NAMES = ['GazaPharmacyDB_v5'];
      for (const name of DB_NAMES) {
        try { indexedDB.deleteDatabase(name); } catch (e) {}
      }
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = window.location.pathname;
    } catch (e) {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
          <div className="text-center max-w-md mx-auto p-8">
            <div className="mx-auto w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-6">
              <AlertTriangle className="h-8 w-8 text-red-600" />
            </div>
            <h1 className="text-xl font-bold text-gray-900 mb-2">Something went wrong</h1>
            <p className="text-sm text-gray-600 mb-4">
              The application encountered an unexpected error.
              {this.state.error?.message?.includes('version') && (
                <span className="block mt-2 text-red-600 font-medium">
                  <Database className="inline h-4 w-4 mr-1 -mt-0.5" />
                  Database version conflict detected.
                </span>
              )}
            </p>
            {this.state.error && (
              <pre className="text-xs bg-gray-900 text-gray-300 p-3 rounded-lg overflow-auto mb-4 text-left" style={{maxHeight: '120px'}}>
                {this.state.error.message}
              </pre>
            )}
            <button
              onClick={this.handleReset}
              className="inline-flex items-center gap-2 rounded-lg bg-emerald-500 px-6 py-3 text-sm font-semibold text-white hover:bg-emerald-600 transition-colors"
            >
              <RefreshCw className="h-4 w-4" />
              Reset & Reload App
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
